import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import {
  Box,
  Typography,
  Link,
  Button,
  Grid,
  Chip,
  Divider,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "sonner";

export default function CreateSeasons(props) {
  const [seasons, setAllSeasons] = useState([]);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
  }));

  const allSeasonAccounts = () => {
    api
      .get(`/account/all/society/seasons/for/member/${props.Psb}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAllSeasons(response.data?.data);
      });
  };

  useEffect(() => {
    allSeasonAccounts();
  }, []);

  const handleSave = (id) => {
    handleOpen();
    const isAccountExist = props.accounts.some((item) => item.ID === id);
    const iinfo = new FormData();
    iinfo.append("passbook_id", props.Psb);
    iinfo.append("member_id", props.member_id);
    iinfo.append("season_id", id);
    if (isAccountExist) {
      handleClose();
      toast.error("Already farming in season");
    } else {
      try {
        api
          .post("/account/new/prod/member/account", iinfo, {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          })
          .then(function (response) {
            toast.success(response.data);
            props.fetchAccounts();
            allSeasonAccounts();
          })
          .finally(function () {
            handleClose();
          });
      } catch (error) {
        console.log(error);
      }
    }
  };

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  }

  const isToday = (someDate) => {
    const today = new Date();
    return (
      someDate.getDate() === today.getDate() &&
      someDate.getMonth() === today.getMonth() &&
      someDate.getFullYear() === today.getFullYear()
    );
  };

  const renderTitle = (name, date) => {
    const formattedDate = formatDateToYearMonthDay(date);
    return (
      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
        {isToday(date) && (
          <Chip variant="outlined" size="small" color="success" label="Today" />
        )}
        <b>
          {" "}
          {name} : {formattedDate} |{" "}
        </b>
      </Typography>
    );
  };

  return (
    <div>
      <Item>
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography
                sx={{ textAlign: "center" }}
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                variant="h3"
              >
                <b>Select Season to Activate</b>
              </Typography>
            </Grid>

            <Grid item xs={12} md={12}>
              {seasons.map((savingItem, index) => (
                <>
                  <div key={index} style={{ display: "flex" }}>
                    <Link
                      sx={{ mr: "auto" }}
                      variant="h6"
                      underline="none"
                      component="button"
                      color="inherit"
                      onClick={() => handleSave(savingItem.id)}
                    >
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="h6"
                      >
                        <b>{savingItem.season_name}</b>
                      </Typography>
                    </Link>
                    {renderTitle("Start date", new Date(savingItem.start_date))}

                    {savingItem.end_date ? (
                      renderTitle("| End date", new Date(savingItem.end_date))
                    ) : (
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>| End date: N/A</b>
                      </Typography>
                    )}

                    <div style={{ marginLeft: "auto" }}>
                      {savingItem.status === "Not Started" ? (
                        <Chip
                          color="warning"
                          variant="outlined"
                          label={savingItem.status}
                          sx={{
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                            minWidth: 0,
                          }}
                          size="small"
                        />
                      ) : savingItem.status === "Ongoing" ? (
                        <Chip
                          color="success"
                          label={savingItem.status}
                          sx={{
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                            minWidth: 0,
                          }}
                          size="small"
                        />
                      ) : savingItem.status === "Ended" ? (
                        <Chip
                          color="action"
                          label={savingItem.status}
                          sx={{
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                            minWidth: 0,
                          }}
                          size="small"
                        />
                      ) : null}
                    </div>
                  </div>
                  <Divider variant="middle" sx={{ m: "10px" }} />
                </>
              ))}
            </Grid>
          </Grid>
        </Box>
        <Button variant="outlined" onClick={() => props.setOpen_acc()}>
          Close
        </Button>
      </Item>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
